import React, { HTMLAttributes } from "react";
import { animated, useInView, useSpring } from "react-spring";
import SectionTitle from "../../../atoms/sectionTitle";
import ChargeText from "../chargeText";

interface IPriceSection {}

type TPriceSectionProps = IPriceSection & HTMLAttributes<HTMLDivElement>;

const PriceSection: React.FC<TPriceSectionProps> = (props) => {
  const { ...otherProps } = props;

  const [ref, inView] = useInView({
    rootMargin: "-10%",
    once: false,
  });

  const firstSpring = useSpring({
    from: { transform: "rotateX(180deg)", opacity: 0 },
    to: inView
      ? { transform: "rotateX(0deg)", opacity: 1 }
      : { transform: "rotateX(180deg)", opacity: 0 },
    config: { tension: 200, friction: 30 },
  });

  const secondSpring = useSpring({
    from: { transform: "rotateX(90deg)", opacity: 0 },
    to: inView
      ? { transform: "rotateX(0deg)", opacity: 1 }
      : { transform: "rotateX(90deg)", opacity: 0 },
    config: { tension: 200, friction: 30 },
    delay: 500,
  });

  const thirdSpring = useSpring({
    from: { transform: "rotateX(90deg)", opacity: 0 },
    to: inView
      ? { transform: "rotateX(0deg)", opacity: 1 }
      : { transform: "rotateX(90deg)", opacity: 0 },
    config: { tension: 200, friction: 30 },
    delay: 800,
  });

  return (
    <div
      ref={ref}
      className="justify-center flex flex-col p-5 laptop:py-10 laptop:px-[10%]"
      {...otherProps}
    >
      <SectionTitle chineseTitle="公平收費" englishTitle="Fair Use Charging" />
      <div className="flex flex-col laptop:flex-row gap-4 laptop:gap-6">
        <animated.div
          style={firstSpring}
          className="flex flex-[2] flex-col gap-3 laptop:gap-5 p-6 laptop:p-8 bg-mainDark rounded-3xl text-white"
        >
          <div className="flex flex-col text-mainYellow">
            <span className="text-2xl laptop:text-3xl font-bold">公平收費</span>
            <span className="text-sm laptop:text-xl">Fair Use Charging</span>
          </div>
          <div className="flex flex-col gap-3 text-lightDark">
            <span className="text-sm laptop:text-lg">
              ASGARD EV
              希望保障每一位使用者的權益，所以我們制定公平收費政策，以協助資源得到妥善利用。
            </span>
            <span className="text-xs laptop:text-base">
              ASGARD EV aims to protect the rights of every user, which is why
              we have established a fair pricing policy to ensure the proper
              utilization of resources.
            </span>
          </div>
        </animated.div>
        <animated.div
          style={secondSpring}
          className="flex flex-row laptop:flex-col flex-1 gap-8 laptop:gap-5 p-8 bg-mainDark rounded-3xl text-white justify-between items-center laptop:items-start"
        >
          <div className="flex flex-col text-mainYellow">
            <span className="text-2xl laptop:text-3xl font-bold">佔用費</span>
            <span className="text-sm laptop:text-xl">Overstay</span>
          </div>
          <div className="flex flex-col text-white">
            <span className="text-4xl laptop:text-4xl font-extrabold">$5</span>
            <span className="text-sm laptop:text-xl">/每分鐘 min</span>
          </div>
        </animated.div>
        <animated.div
          style={thirdSpring}
          className="flex flex-row laptop:flex-col flex-1 gap-8 laptop:gap-5 p-8 bg-mainDark rounded-3xl text-white justify-between items-center laptop:items-start"
        >
          <div className="flex flex-col text-mainYellow">
            <span className="text-2xl laptop:text-3xl font-bold">
              非充電動汽車使用
            </span>
            <span className="text-sm laptop:text-base font-bold">
              Non-electric vehicle use
            </span>
          </div>
          <div className="flex flex-col text-white">
            <span className="text-4xl laptop:text-4xl font-extrabold">
              $320
            </span>
            <span className="text-sm laptop:text-base font-bold">
              /解鎖費用
            </span>
          </div>
        </animated.div>
      </div>
      <ChargeText />
    </div>
  );
};

export default PriceSection;
